export default __webpack_public_path__ + "static/media/top_nav_shopping_bag.4dfdd4b5.svg";